import { useAlbumStore, useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import { useState, useEffect } from "react";
import "../style/Collection.css";
import FilterGroup from "../components/album/FilterGroup";
import SortAlbum from "../components/album/SortAlbum";
import ListAlbum from "../components/album/ListAlbum";
import Header from "../components/general/Header";
import WaitingAnimation from "../components/general/WaitingAnimation";
// images
import vinyleImg from "/images/vinyle.svg";

import { Youtube } from 'lucide-react';
const CROISSANT = false;
const DECROISSANT = true;

const Collection = observer(() => {
  const albumStore = useAlbumStore();
  const profilStore = useProfilStore();
  const [showIntroImage, setShowIntroImage] = useState(true);
  //TODO à remettre à true
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowIntroImage(false);
    }, 1000); // durée de l'animation

    return () => clearTimeout(timeout);
  }, []);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedSorting, setSelectedSorting] = useState("title");
  const [selectedSortingOrder, setSelectedSortingOrder] = useState(CROISSANT);


  // METHODS
  const handleGroupChange = (group) => {
    setSelectedGroup(group); // Met à jour l'état du groupe sélectionné
  };

  const handleSortChange = ({type, order}) => {
    setSelectedSorting(type);
    setSelectedSortingOrder(order);
  };

  return (
    <main className={`collection_main ${showIntroImage && `albumsintro`}`}>
      {showIntroImage && (
        <img
          src={vinyleImg}
          alt="Intro"
          className="collection_intro-img animate"
        ></img>
      )}
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      { albumStore.isLoaded ?
        <section className="collection_content">
          <div className="collection_param-box">
            <FilterGroup groupList={albumStore.groupListSorted({type:"alphabetical"})} onSelect={handleGroupChange}/>
            <div className="collection_separator"></div>
            <SortAlbum onChange={handleSortChange} disableGroupSorting={selectedGroup !== null}/>
          </div>
          <p className="collection_consigne">Cliquez sur les cover d'album pour révéler des informations supplémentaires</p>
          {!selectedGroup?null:
            <div className="collection_groupDiv">
              <a className="collection_groupNameDiv" href={albumStore.getGroupById(selectedGroup).youtube} target="_blank">
                <h2 className="collection_groupName">{albumStore.getGroupById(selectedGroup).name}</h2>
                <Youtube className="collection_groupNameYoutube" size={45} color="#fff" strokeWidth={1.2}/>
              </a>
              <p className="collection_groupPresentation">{albumStore.getGroupById(selectedGroup).presentation}</p>
            </div>
          }
          <ListAlbum albumStore={albumStore} filterAlbum={selectedGroup} sortingType={selectedSorting} sortingOrder={selectedSortingOrder} showGroup={true} showCorrectionOnFlip={true} showTitle={true} onCLick={() => ``} />
        </section>
        : <WaitingAnimation/>
      }

    </main>
  );
});

export default Collection;
